import { AloftPriceJSON } from '@aloft/shared-objects';
import {
  CombinedManualAdjustmentType,
  isDefined,
  schCombinedManualAdjustmentType,
  schFormNumber,
} from '@aloft/toolkit-shared';

import { z } from 'zod';

// TODO: move general form types somewhere outside of the analysis module
import { schPrice } from '../../modules/analysis/types.ts';

const schAdjustmentException = z
  .array(
    z.object({
      adjustmentType: schCombinedManualAdjustmentType,
      value: schPrice,
    }),
  )
  .refine(
    (roundingAdjustments) => {
      const adjustmentTypes = roundingAdjustments.map((adjustment) => adjustment.adjustmentType);
      return new Set(adjustmentTypes).size === adjustmentTypes.length;
    },
    { message: 'Adjustment types must be unique' },
  )
  .transform((roundingAdjustments) => {
    const rounding: Partial<Record<CombinedManualAdjustmentType, AloftPriceJSON>> = {};
    roundingAdjustments.forEach((adjustment) => {
      if (isDefined(adjustment.value)) {
        rounding[adjustment.adjustmentType] = adjustment.value;
      }
    });
    return rounding;
  });

const schTextBoolean = z
  .string()
  .regex(/[true|false]/)
  .transform((val) => val === 'true');

export const schSettingsForm = z.object({
  roundingDefault: schPrice.optional(),
  rounding: schAdjustmentException.optional(),
  thresholdDefault: schPrice.optional(),
  threshold: schAdjustmentException.optional(),
  depreciateSeparately: schTextBoolean.optional(),
  enableFunctionalDepreciation: schTextBoolean.optional(),
  enableExternalDepreciation: schTextBoolean.optional(),
  defaultEcoLife: schFormNumber.optional(),
  defaultEcoLifeManufactured: schFormNumber.optional(),
  defaultEcoLifeGarage: schFormNumber.optional(),
  defaultEcoLifeCarport: schFormNumber.optional(),
  defaultEcoLifePorch: schFormNumber.optional(),
  defaultEcoLifePatio: schFormNumber.optional(),
  defaultEcoLifeDeck: schFormNumber.optional(),
  defaultEcoLifeWorkshop: schFormNumber.optional(),
  defaultEcoLifeShed: schFormNumber.optional(),
  defaultEcoLifeBarn: schFormNumber.optional(),
  defaultEcoLifePool: schFormNumber.optional(),
  defaultEcoLifeSpa: schFormNumber.optional(),
  defaultEcoLifeADU: schFormNumber.optional(),
  defaultEcoLifeManualCost: schFormNumber.optional(),
  defaultEcoLifeFireplace: schFormNumber.optional(),
});

export type SettingsFormOutput = z.output<typeof schSettingsForm>;
